import { MIN_AGE_DOB } from "../constants/static-data.constants";
export function performValidation(
  pageData: any,
  sectionData: any,
  actionName: string,
  pageName?: string,
  additionalData?: any,
  leadSubmissionFlow?: string,
  enrollmentType?: string
): any {
  console.log('performValidation form data =====>', pageData);
  console.log('performValidation section data ====>', sectionData);
  console.log('performValidation pageName ====>', pageName);
  console.log('performValidation additionalData ====>', additionalData);

  const customFunctionList = {
    providerLeadValidateSSN: (data: any) => providerLeadValidateSSN(data),
    validateSSN: (data: any) => validateSSN(data),
    validateStartDate: (data: any) => validateStartDate(data),
    mobileValidation: (data: any) => mobileValidation(data),
    telephoneValidation: (data: any) => telephoneValidation(data),
    pdrPhoneValidation: (data: any) => pdrPhoneValidation(data),
    validateMinAgeDOB: (data : any) => validateMinAgeDOB(data, leadSubmissionFlow, enrollmentType),
    validateMaxAgeDOB: (data : any) => validateMaxAgeDOB(data)
  };

  let validationList: any[] = [];
  let actions: any[] = [];

  validationList = getValidationList(sectionData);
  actions = getActions(sectionData);

  const actionValidationList = getActionValidationList(actionName, actions);

  let validationErrorMessages: any = {};

  actionValidationList.forEach((validationActionGroup: any) => {
    switch (validationActionGroup.checkType) {
      case 'atLeastXEntered': {
        try {
          const { attributes } = getAttributesForCheckType(
            validationActionGroup.checkType,
            validationList
          );

          attributes?.forEach((attribute: any) => {
            const { attribute_ID, functionParams } = attribute;

            // TODO: Perform validation based on functionParams and attribute_ID
            let fieldData = 0;
            const fieldErrorMessage: any = {};
            attribute_ID.forEach((attrId: string) => {
              if (fieldHasData(pageData[attrId])) {
                fieldData++;
              } else {
                fieldErrorMessage[attrId] = functionParams.ErrMsg;
              }
            });

            if (
              Object.prototype.hasOwnProperty.call(
                functionParams,
                'minNeeded'
              ) &&
              fieldData < functionParams.minNeeded
            ) {
              validationErrorMessages = {
                ...validationErrorMessages,
                ...fieldErrorMessage,
              };
            } else if (
              !Object.prototype.hasOwnProperty.call(functionParams, 'minNeeded')
            ) {
              validationErrorMessages = {
                ...validationErrorMessages,
                ...fieldErrorMessage,
              };
            }
          });
        } catch (e) {
          console.log('Error in performing atLeastXEntered validation', e);
        }

        break;
      }

      case 'checkFieldValue': {
        // case 'checkFieldValue'

        try {
          const { attributes } = getAttributesForCheckType(
            validationActionGroup.checkType,
            validationList
          );

          attributes?.forEach((attribute: any) => {
            const { attribute_ID, functionParams } = attribute;

            // TODO: Perform validation based on functionParams and attribute_ID
            const fieldErrorMessage: any = {};
            attribute_ID.forEach((attrId: string) => {
              const fieldData = pageData[attrId];

              if (
                Object.prototype.hasOwnProperty.call(
                  functionParams,
                  'isNullAllowed'
                ) &&
                functionParams.isNullAllowed.toLowerCase() === 'n' &&
                fieldHasData(fieldData)
              ) {
                if (
                  Object.prototype.hasOwnProperty.call(
                    functionParams,
                    'Maxlength'
                  ) &&
                  functionParams.Maxlength > 0
                ) {
                  if (fieldData.length > functionParams.Maxlength) {
                    fieldErrorMessage[attrId] = functionParams.ErrMsg;
                  }
                }
                if (
                  Object.prototype.hasOwnProperty.call(
                    functionParams,
                    'Minlength'
                  ) &&
                  functionParams.Minlength > 0
                ) {
                  if (fieldData.length < functionParams.Minlength) {
                    fieldErrorMessage[attrId] = functionParams.ErrMsg;
                  }
                }

                if (
                  Object.prototype.hasOwnProperty.call(
                    functionParams,
                    'Format'
                  ) &&
                  functionParams.Format.length > 0
                ) {
                  if (
                    !testRegularExpression(fieldData, functionParams.Format)
                  ) {
                    fieldErrorMessage[attrId] = functionParams.ErrMsg;
                  }
                }

                if (
                  Object.prototype.hasOwnProperty.call(
                    functionParams,
                    'CheckDate'
                  ) &&
                  functionParams.CheckDate
                ) {
                  const dob = new Date(fieldData);
                  const today = new Date();
                  today.setHours(0, 0, 0, 0);

                  if (dob >= today) {
                    fieldErrorMessage[attrId] = functionParams.ErrMsg;
                  }
                }
              }
            });

            validationErrorMessages = {
              ...validationErrorMessages,
              ...fieldErrorMessage,
            };
          });
        } catch (e) {
          console.error('Error in performValidation validation', e);
        }

        break;
      }

      case 'conditionalCheck': {
        // case 'conditionalCheck'

        try {
          const { attributes } = getAttributesForCheckType(
            validationActionGroup.checkType,
            validationList
          );

          attributes?.forEach((attribute: any) => {
            const { functionParams } = attribute;

            const {
              basecondition,
              baseconditionValue,
              condtionalAttributes,
              Format,
              ErrMsg,
            } = functionParams;

            // TODO: Perform validation based on functionParams and attribute_ID
            const fieldErrorMessage: any = {};
            let baseConditionFieldHasData = 0;

            basecondition.forEach((attrId: string, idx: number) => {
              // TODO: Perform data check if the baseconditionValue doesn't exists
              if (!baseconditionValue) {
                if (fieldHasData(pageData[attrId])) {
                  baseConditionFieldHasData++;
                }
              }

              // TODO: Perform data check if the baseconditionValue exists
              if (baseconditionValue) {
                if (
                  fieldHasData(pageData[attrId]) &&
                  pageData[attrId] === baseconditionValue[idx]
                ) {
                  baseConditionFieldHasData++;
                }
              }
            });

            // if the base condition is met, validate the condtional attributes
            if (baseConditionFieldHasData === basecondition.length) {
              if (Format && Format.length > 0) {
                condtionalAttributes.forEach((attrId: string) => {
                  if (
                    fieldHasData(pageData[attrId]) &&
                    !testRegularExpression(pageData[attrId], Format)
                  ) {
                    fieldErrorMessage[attrId] = ErrMsg;
                  }
                });
              } else {
                condtionalAttributes.forEach((attrId: string) => {
                  if (!fieldHasData(pageData[attrId])) {
                    fieldErrorMessage[attrId] = ErrMsg;
                  }
                });
              }
            }

            // merger the validation error messages
            validationErrorMessages = {
              ...validationErrorMessages,
              ...fieldErrorMessage,
            };
          });
        } catch (error) {
          console.error(
            'Error in performing conditionalCheck validation',
            error
          );
        }

        break;
      }

      case 'customValidator': {
        // case 'customFunction'

        try {
          const { attributes } = getAttributesForCheckType(
            validationActionGroup.checkType,
            validationList
          );

          attributes?.forEach((attribute: any) => {
            const { functionParams, attribute_ID } = attribute;

            const { validatorFunction, ErrMsg } = functionParams;
            const fieldErrorMessage: any = {};

            // fetch the function based on the configuration and perform validation
            const validatorResp = (customFunctionList as any)[
              validatorFunction
            ](pageData);

            if (validatorResp && attribute_ID.length > 0) {
              attribute_ID.forEach((ele: string) => {
                fieldErrorMessage[ele] = ErrMsg;
              });
            }

            validationErrorMessages = mergeValidationErrors(
              validationErrorMessages,
              fieldErrorMessage
            );
          });
        } catch (error) {
          console.error(
            'Error in performing customValidator validation',
            error
          );
        }

        break;
      }
    }
  });

  console.log('validationErrorMessages ====>', validationErrorMessages);
  return validationErrorMessages;
}

// get actiion list for a specific action name
function getActionValidationList(actionName: string, actionList: any[]): any {
  const validations = actionList.find(
    (action: any) => action.Name === actionName
  );
  if (validations) {
    return validations.Validate;
  } else {
    return [];
  }
}

// get actions from section data
function getActions(sectionData: any): any {
  return sectionData.actions;
}

// get validations list from section data
function getValidationList(sectionData: any): any {
  return sectionData.validations;
}

// get attributes for a specific check type (atLeastXEntered) from validations list
function getAttributesForCheckType(
  validationType: string,
  validationList: any[]
): any {
  const validations = validationList.filter(
    (validation: any) => validation.whatToCheck === validationType
  );
  const attributes = { attributes: [] };
  if (validations.length > 0) {
    return validations[0];
  }
  return attributes;
}

//check if field has the data
function fieldHasData<T>(field: T): boolean {
  if (Array.isArray(field)) {
    return field.length > 0;
  } else if (typeof field === 'string') {
    const value = field ? field?.trim() : field;
    return value && (value !== '' || value !== null || value !== undefined)
      ? true
      : false;
  } else if (typeof field === 'number') {
    return field > 0;
  } else if (
    typeof field === 'object' &&
    !Array.isArray(field) &&
    field !== null &&
    field !== undefined
  ) {
    if (field instanceof Date) {
      return true;
    } else if (field instanceof Object) {
      return Object.entries(field as object).length > 0;
    } else {
      return false;
    }
  } else if (typeof field === 'boolean') {
    return field;
  }

  return false;
}

// test regular expression function
function testRegularExpression(value: string, regexString: string): boolean {
  const regex = new RegExp(regexString);
  return regex.test(value);
}

// custom validator function for validationg ssn starting with 9
function providerLeadValidateSSN(formData: any) {
  /*  let formData  = JSON.parse(formFieldData); */
  console.log('ssn validate', formData);
  if (
    formData?.SSN &&
    formData?.isProvidingServices &&
    formData?.isProvidingServices?.toLowerCase() == 'yes'
  ) {
    // Male SSN format is 999-99-9999
    const ssn = formData.SSN.replace(/-/g, '');
    const regex = new RegExp(/^9\d*/);

    if (regex.test(ssn)) {
      return true;
    }
  }
  return false;
}

function validateMinAgeDOB(formData: any, leadSubmissionFlow?: string, enrollTypeString?: any) {
  if (formData?.dob) {
    const dob = new Date(formData.dob);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diff = today.getFullYear() - dob.getFullYear();

    const enrollType = enrollTypeString ?? '';
    let enrollmentType;
    if (enrollType && Array.isArray(enrollType)) {
      if (enrollType.length > 1) {
        if (enrollType.includes('provider')) {
          enrollmentType = ['provider'];
        } else if (enrollType.includes('authRepresentative')) {
          enrollmentType = ['authRepresentative'];
        } else if (enrollType.includes('poa')) {
          enrollmentType = ['poa'];
        } else if (enrollType.includes('legalGuardian')) {
          enrollmentType = ['legalGuardian'];
        }
      } else {
        enrollmentType = enrollType[0];
      }
    } else {
      enrollmentType = null;
    }

    let minAge;
    if (
      (leadSubmissionFlow === 'participantEnrollment' ||
        leadSubmissionFlow === 'providerEnrollment') &&
      enrollmentType
    ) {
      minAge =
        enrollmentType && MIN_AGE_DOB[enrollmentType]
          ? MIN_AGE_DOB[enrollmentType]
          : 0;
    } else {
      minAge =
        leadSubmissionFlow && MIN_AGE_DOB[leadSubmissionFlow]
          ? MIN_AGE_DOB[leadSubmissionFlow]
          : 0;
    }
    console.log('minage  ', minAge);
    if (diff < minAge) {
      return true;
    }
  }
  return false;
}

function validateMaxAgeDOB(formData: any) {
  if(formData?.dob) {
    const dob = new Date(formData.dob);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diff = today.getFullYear() - dob.getFullYear();

    if(diff > 150) {
      return true;
    }
  }

  return false;
}

function validateSSN(formData: any) {
    /*  let formData  = JSON.parse(formFieldData); */
    console.log('ssn validate', formData);
    if(formData?.SSN) {
        const ssn = formData.SSN.replace(/-/g, '');
        const regex = /^\d{9}$/;
        
        const ssnRegex = /^(?!666|000|9\d{2})(?!.*(\d)(?:\1){8})(?!123456789)\d{3}(?!00)\d{2}(?!0000)\d{4}$/;
        const reservedSsn = ['078051120', '721074426', '219099999']

        // Check if ssn has exactly 9 digits first
        if (!regex.test(ssn)) {
          return true;
        }

        // Validate the ssn against the main regex
        if (!ssnRegex.test(formData.SSN)) {
          return true;
        }

        if(reservedSsn.includes(formData.SSN)) {
          return true;
        }
  }
  return false;
}
function mobileValidation(formData: any) {
  console.log('phone validate', formData);
  let phoneNumber;

  if (formData?.mobile) {
    phoneNumber = formData?.mobile;

  if (!/^\d{10}$/.test(phoneNumber)) {
    return true;
  }

  // Disallow numbers composed of the same digit
  if (/^(.)\1{9}$/.test(phoneNumber)) {
    return true;
  }

  // Disallow unrealistic patterns like 1234567890, 9876543210, etc.
  const unrealisticPatterns = [
    '1234567890',
    '9876543210',
    '0123456789',
    '1234567890',
  ];
  if (unrealisticPatterns.includes(phoneNumber)) {
    return true;
  }
  // Disallow toll-free numbers and reserved numbers (starting with 800, 888, 911, etc.)
  const tollFreePrefixes = [
    '800',
    '888',
    '877',
    '866',
    '855',
    '844',
    '833',
    '822',
  ];
  const reservedPrefixes = ['911', '411', '611', '811', '555'];

  if (
    tollFreePrefixes.includes(phoneNumber.slice(0, 3)) ||
    reservedPrefixes.includes(phoneNumber.slice(0, 3))
  ) {
    return true;
  }

  // Check if the area code or central office code starts with 0 or 1
  const areaCode = phoneNumber.slice(0, 3);
  const centralOfficeCode = phoneNumber.slice(3, 6);
  if (
    areaCode[0] === '0' ||
    areaCode[0] === '1' ||
    centralOfficeCode[0] === '0' ||
    centralOfficeCode[0] === '1'
  ) {
    return true;
  }
}

  return false;
}

function pdrPhoneValidation(formData: any) {
  return mobileValidation({ mobile: formData?.pdrPhone });
}

function telephoneValidation(formData: any) {
    console.log('phone validate', formData);
    let phoneNumber;
    if (formData?.altPhone) {
      phoneNumber = formData?.altPhone;
  
    if (!/^\d{10}$/.test(phoneNumber)) {
      return true;
    }
  
    // Disallow numbers composed of the same digit
    if (/^(.)\1{9}$/.test(phoneNumber)) {
      return true;
    }
  
    // Disallow unrealistic patterns like 1234567890, 9876543210, etc.
    const unrealisticPatterns = [
      '1234567890',
      '9876543210',
      '0123456789',
      '1234567890',
    ];
    if (unrealisticPatterns.includes(phoneNumber)) {
      return true;
    }
    // Disallow toll-free numbers and reserved numbers (starting with 800, 888, 911, etc.)
    const tollFreePrefixes = [
      '800',
      '888',
      '877',
      '866',
      '855',
      '844',
      '833',
      '822',
    ];
    const reservedPrefixes = ['911', '411', '611', '811', '555'];
  
    if (
      tollFreePrefixes.includes(phoneNumber.slice(0, 3)) ||
      reservedPrefixes.includes(phoneNumber.slice(0, 3))
    ) {
      return true;
    }
  
    // Check if the area code or central office code starts with 0 or 1
    const areaCode = phoneNumber.slice(0, 3);
    const centralOfficeCode = phoneNumber.slice(3, 6);
    if (
      areaCode[0] === '0' ||
      areaCode[0] === '1' ||
      centralOfficeCode[0] === '0' ||
      centralOfficeCode[0] === '1'
    ) {
      return true;
    }
  }
  
    return false;
  }

function validateStartDate(formData: any) {
  console.log('starDate validate', formData);

  if (formData?.eligiblityEndDate && !formData?.eligiblityStartDate) {
    return true;
  }
  return false;
}

function mergeValidationErrors(
  validationErrorMsgs: any,
  currentErrorMsgs: any
): any {
  const validationErrorMessages = {
    ...validationErrorMsgs,
    ...currentErrorMsgs,
  };
  return validationErrorMessages;
}
